import {
  Action,
  deleteInvocesToken,
  existedInvocesToken,
  newInvocesToken,
  saveToken,
  Trigger,
} from '../../defaults';

export const validationTriggers: Trigger[] = [
  {
    events: ['on-click'],
    targets: [saveToken],
    handlers: ['saveStatus-to-trigger-validation', 'trigger-validation'],
  },

  {
    events: ['on-change-any-data-param'],
    targets: [saveToken],
    handlers: ['check-validation'],
    expr: {
      type: 'func',
      value: `({hashMap}) => hashMap['${saveToken}'].data.customData.saveStatus === 'trigger-validation'`,
    },
  },
];

/* eslint-disable */
export const validationActions: Action[] = [
  {
    kind: 'changes',
    token: 'saveStatus-to-trigger-validation',
    spec: {
      target: saveToken,
      changes: {
        'data.customData.saveStatus': {
          type: 'val',
          value: 'trigger-validation',
        },
      },
    },
  },

  {
    kind: 'func',
    token: 'trigger-validation',
    spec: {
      func: `({triggerValidation, config}) => triggerValidation(config.sduiId)`,
    },
  },

  {
    kind: 'changes',
    token: 'check-validation',
    spec: {
      target: saveToken,
      changes: {
        'data.customData.saveStatus': {
          type: 'func',
          value: `({hashMap}) => {
  if (!hashMap['${newInvocesToken}'].child.length && !hashMap['${existedInvocesToken}'].child.length && !!hashMap['${deleteInvocesToken}'].data.value.length) {
    return 'valid'
  }

  const valid = !Object.values(hashMap).filter(({data}) => data.valid === false).length

  return valid ? 'valid' : 'not-valid'
}`,
        },
      },
    },
  },
];
/* eslint-enable */
